import React from 'react';
import { Routes, Route } from "react-router-dom";
import InvestorRegistrationList from "./investor-registration-list/investor-registration-list";

const InvestorRegistrations = () => {
  return (
    <Routes>
      <Route index element={<InvestorRegistrationList />} />
    </Routes>
  )
}

export default InvestorRegistrations;
